(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ModelMeterDeleteController',ModelMeterDeleteController);

    ModelMeterDeleteController.$inject = ['$uibModalInstance', 'entity', 'ModelMeter'];

    function ModelMeterDeleteController($uibModalInstance, entity, ModelMeter) {
        var vm = this;
        vm.modelMeter = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ModelMeter.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
